
class CustomAccordion extends HTMLElement{
    constructor(){
        super();

        //Seleccionar todas las preguntas
        this.questions = Array.from(this.querySelectorAll(".question"))

        this.accordionImg = this.querySelector(".accordion-img")

        //Agregar al método el this
        this.openQuestion = this.openQuestion.bind(this)

        //Agregar un evento Click a cada pregunta
        this.questions.forEach(question=>{
            question.addEventListener("click",()=>this.openQuestion(question.id))
        })
    }

    openQuestion(questionId) {
        
        this.questions.forEach(question => {
            const subtext = question.querySelector(".col-start-2");
            if (question.id !== questionId) {
                question.classList.remove("opened-question");
                /* subtext.classList.remove("opened-question"); */
                if(!subtext.classList.contains("closed-question")){
                    subtext.classList.add("closed-question");
                }
            } else {
                question.classList.add("opened-question");
                if(subtext.classList.contains("closed-question")){
                    subtext.classList.remove("closed-question");
                }
                if(this.accordionImg){
                    this.accordionImg.srcset = question.dataset.img
                }
            }
        });
    }
}

customElements.define("custom-accordion", CustomAccordion)